module.exports = __webpack_public_path__ + "img/login_point2.e483a8c1.png";